import React, { useState, useEffect } from 'react';
import { Drawer, Select, Switch, Button, Modal, Form, Input } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import globalData from "../../../../config/global_data";
import common_api from '../../../../config/common_api';
import { triggerNotification } from '../../notify';

const { Option } = Select;

const BulkPriceDrawer = ({ open, onClose, selectedData, setisloader, globalList, setGlobalList }) => {
    const [form] = Form.useForm();
    const [applyToAll, setApplyToAll] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tabActive, setTabActive] = useState(null);
    const [isConfirmVisible, setIsConfirmVisible] = useState(false);
    const [nextCheckedState, setNextCheckedState] = useState(false);
    const [allNewMsrp, setAllNewMsrp] = useState('');
    const [allNewSalePrice, setAllNewSalePrice] = useState('');
    const isSaveDisabled = tableData.some(item => !item.inventorySplit);


    const setNewTableData = async () => {
        
        let xmappedData = selectedData.map((item, index) => {
            let variant_sale_price = 0, variant_msrp = 0
            if (item.variant_arr && item.variant_arr.length > 0) {
                let selected_variant = item.variant_arr.find(itemIn => itemIn.variant_sku === item.sapSku)
                if (selected_variant) {
                    variant_sale_price = selected_variant.variant_sale_price
                    variant_msrp = selected_variant.variant_msrp
                }
            }            
            
            const newItem = {
                key: item.key,
                name: item.sapName,
                sku: item.sapSku,
                store: item.store,
                sapMsrp: item.sapMsrp,
                sapPrice: item.sapPrice,
                type: item.type,
                prdouct_data: item.prdouct_data,
                prod_sale_price: item.prod_sale_price,
                variant_data_msrp: variant_msrp,
                variant_data_sale: variant_sale_price,
                variant_id: item.variant_data?.variant_id,
                prod_id: item.prod_id,
                newMsrp: '',
                newSalePrice: '',
                store_id: item.store_id, 
                currency_symbol: selectedData.currency_symbol,            
            };

            if (index === 0) setTabActive(newItem);
            return newItem;
        });

        setTableData(xmappedData);
    };

    useEffect(() => {
        if (selectedData?.length > 0) {
            setNewTableData();
        }
    }, [selectedData]);
    const handleSaveAndPublish = async (is_open) => {
        try {
            await form.validateFields();
        } catch (error) {
            triggerNotification({
                type: 'error',
                title: 'Required!',
                message: "Please fix all errors before saving.",
            });
            return;
        }
        let updatedTableData = tableData;
        if (applyToAll) {
            updatedTableData = tableData.map(item => ({
                ...item,
                newMsrp: allNewMsrp,
                newSalePrice: allNewSalePrice
            }));
        }
        let req_data = {}

        let variant_products = updatedTableData
            .filter(item => item.type === "Variant")
            .map(item => ({
                product_id: parseInt(item.prod_id),
                store_id: parseInt(item.store_id),
                price: parseInt(item.newMsrp) || 0,
                sale_price: parseInt(item.newSalePrice) || 0,
                id: parseInt(item.variant_id)
            }))
        let simple_products = updatedTableData
            .filter(item => item.type === "Simple")
            .map(item => ({
                product_id: parseInt(item.prod_id),
                store_id: parseInt(item.store_id),
                price: parseInt(item.newMsrp) || 0,
                sale_price: parseInt(item.newSalePrice) || 0
            }))

        if (variant_products && variant_products.length > 0) {
            req_data.variant_products = variant_products
        }
        if (simple_products && simple_products.length > 0) {
            req_data.simple_products = simple_products
        }
        // return 1
        setisloader(true);
        let responsedata = await common_api.bulk_price_update(req_data);

        if (responsedata) {
            let alldata = await common_api.set_all_madded_data_to_variables_bulk(globalList, responsedata)
            if (alldata) {
                await setGlobalList(alldata)
            }
            triggerNotification(responsedata)
        }

        setisloader(false);
        onClose();
    };

    return (
        <Drawer
            className='BulkEditDrawer'
            title={`Bulk Price (${tableData.length})`}
            width={'calc(100% - 256px)'}
            onClose={onClose}
            open={open}
            extra={
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        onClick={e => handleSaveAndPublish(true)}
                    // disabled={isSaveDisabled}
                    >
                        Save & Continue Editing
                    </Button>
                    <Button
                        type="primary"
                        onClick={e => handleSaveAndPublish(false)}
                    // disabled={isSaveDisabled}
                    >
                        Save Changes
                    </Button>
                </div>
            }
        >
            <Form layout="vertical" form={form}>
                <div className={`selectedFieldBoxRow`}>
                    <div className={``}>
                        <div className='BulkTogglebuton' style={{ display: 'flex', marginBottom: 8 }}>
                            <span style={{ marginRight: 8 }}>Apply to all ({tableData.length})</span>
                            <Switch
                                checked={applyToAll}
                                onChange={(checked) => {
                                    if (checked) {
                                        setNextCheckedState(true);
                                        setIsConfirmVisible(true);
                                    } else {
                                        setApplyToAll(false);
                                    }
                                }}
                            />
                            {applyToAll && (
                                <div
                                    className={`drawer-row gift-drawer-row ApplyToAllDrawerRow`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="drawer-info" style={{ width: "200px" }}>
                                        <div className="drawer-title">
                                            <Form.Item
                                                label={
                                                    <span>
                                                        New MSRP&nbsp;
                                                    </span>
                                                }
                                                name="msrpPrice"
                                                rules={[
                                                    { required: true, message: "Please enter the Store MSRP" },
                                                ]}
                                            >
                                                <Input
                                                    type='number'
                                                    placeholder="Enter New MSRP"
                                                    value={allNewMsrp}
                                                    onChange={e => setAllNewMsrp(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === '-' || e.key === 'e') {
                                                            e.preventDefault(); // blocks minus and exponential notation
                                                        }
                                                    }}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className="drawer-info">
                                        <div className="drawer-title">
                                            <Form.Item
                                                label={
                                                    <span>
                                                        New Sale Price&nbsp;
                                                    </span>
                                                }
                                                name="salePrice"
                                                rules={[
                                                    { required: true, message: "Please enter the sale price" },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const msrp = parseFloat(getFieldValue('msrpPrice'));
                                                            const sale = parseFloat(value);
                                                            if (!value || isNaN(msrp) || isNaN(sale) || sale <= msrp) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject('Sale Price cannot be greater than MSRP');
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input
                                                    type='number'
                                                    min={0}
                                                    max={100}
                                                    placeholder="Enter New Sale Price"
                                                    value={allNewSalePrice}
                                                    onChange={e => setAllNewSalePrice(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === '-' || e.key === 'e') {
                                                            e.preventDefault(); // blocks minus and exponential notation
                                                        }
                                                    }}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>

                                </div>
                            )}
                        </div>
                        <div className="DrawerTableList bulkPriceDrawerTableList">
                            {tableData.map((item, idx) => (
                                <div
                                    key={item.key}
                                    className={`drawer-row gift-drawer-row`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="drawer-info first">
                                        <div className="drawer-title">{item.name}</div>
                                        <div className="drawer-sub">{item.sku} – {item.store} - {item.type}</div>
                                    </div>
                                    <div className="drawer-info">
                                        <div className="drawer-title">
                                            <Form.Item
                                                label={
                                                    <span>
                                                        Current MRSP
                                                    </span>
                                                }
                                            >
                                                {item.type == "Variant" && (
                                                    <span>{selectedData[0].currency_symbol} {item.variant_data_msrp}</span>
                                                )}
                                                {item.prdouct_data?.prod_msrp && (
                                                    <span>{selectedData[0].currency_symbol} {item.prdouct_data.prod_msrp}</span>
                                                )}
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {!applyToAll && (
                                        <div className="drawer-info" style={{ width: "200px" }}>
                                            <div className="drawer-title">
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            New MSRP&nbsp;
                                                        </span>
                                                    }
                                                    name={`msrpPrice_${idx}`}
                                                    rules={[
                                                        { required: true, message: "Please enter the Store MSRP" },
                                                    ]}
                                                >
                                                    <Input
                                                        type='number'
                                                        min={0}
                                                        max={100}
                                                        placeholder="Enter New MSRP"
                                                        value={item.newMsrp}
                                                        prefix={selectedData[0]?.currency_symbol}
                                                        onChange={e => {
                                                            const value = e.target.value;
                                                            setTableData(prev => prev.map(row => row.key === item.key ? { ...row, newMsrp: value } : row));
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault(); // blocks minus and exponential notation
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    )}
                                    <div className="drawer-info">
                                        <span className='drawer-sub' style={{ paddingBottom: "16px" }}>Current Sale Price</span>
                                        <div className="drawer-title">
                                            {item.type == "Variant" && (
                                                <span>{selectedData[0]?.currency_symbol} {item.variant_data_sale}</span>
                                            )}
                                            {item.prdouct_data?.prod_sale_price && (
                                                <span>{selectedData[0]?.currency_symbol} {item.prdouct_data.prod_sale_price}</span>
                                            )}
                                        </div>
                                    </div>
                                    {!applyToAll && (
                                        <div className="drawer-info" style={{ width: "200px" }}>
                                            <div className="drawer-title">
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            New Sale Price&nbsp;
                                                        </span>
                                                    }
                                                    name={`salePrice_${idx}`}
                                                    rules={[
                                                        { required: true, message: "Please enter the sale price" },
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                const msrp = parseFloat(getFieldValue(`msrpPrice_${idx}`));
                                                                const sale = parseFloat(value);
                                                                if (!value || isNaN(msrp) || isNaN(sale) || sale <= msrp) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject('Sale Price cannot be greater than MSRP');
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input
                                                        type='number'
                                                        min={0}
                                                        max={100}
                                                        placeholder="Enter New Sale Price"
                                                        value={item.newSalePrice}
                                                        prefix={selectedData[0]?.currency_symbol}
                                                        onChange={e => {
                                                            const value = e.target.value;
                                                            setTableData(prev => prev.map(row => row.key === item.key ? { ...row, newSalePrice: value } : row));
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault(); // blocks minus and exponential notation
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Form>

            <Modal
                className='CustomApplyModal'
                title="Apply to All"
                open={isConfirmVisible}
                centered
                onOk={() => {
                    setApplyToAll(true);
                    setTableData(prev =>
                        prev.map(item => ({ ...item }))
                    );
                    setIsConfirmVisible(false);
                }}
                onCancel={() => {
                    setIsConfirmVisible(false);
                    setNextCheckedState(false);
                }}
                okText="Apply To All"
                cancelText="Cancel"
            >
                <div>Are you sure you want to apply this change to all selected items?</div>
            </Modal>
        </Drawer>
    );
};

export default BulkPriceDrawer;
